var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"d-flex"},[_c('span',{staticClass:"v-skeleton-loader__bone"}),(_vm.multiple)?_c('v-icon',[_vm._v("mdi-chevron-right")]):_vm._e(),(_vm.multiple)?_c('span',{staticClass:"v-skeleton-loader__bone"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }